module.exports = __webpack_public_path__ + "img/Lexus.d6e621ff.png";